import styled from 'styled-components';

interface ContainerProps {
  color: 'yellow' | 'green';
}

const colors = {
  yellow: '#4c39fb',
  green: '#3f4d99',
};

export const Container = styled.div<ContainerProps>`
  width: 190px;
  height: 59.19px;

  display: flex;
  align-items: center;
  background: ${(props) => colors[props.color]};
  border-radius: 10px;

  img {
    width: 110px;
    height: 110px;
    margin-left: -12px;
  }

  @media (max-width: 600px) {
    width: 100px;
    height: 59.19px;

    img {
      width: 50px;
      height: 50px;
      margin-left: 0;
    }
  }
`;


export const Content = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: #fff;

  p {
    font-size: 0.8rem;
    line-height: 1rem;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 0.7rem;
  }

  strong {
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    line-height: 1.5rem;
    font-weight: 500;
    text-align: center;
  }
  @media (max-width: 600px) {
    p {
      font-size: 0.4rem;
      line-height: 0.5rem;
      font-weight: 500;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 0.7rem;
    }

    strong {
      margin-bottom: 0.5rem;
      font-size: 1rem;
      line-height: 1rem;
      font-weight: 500;
      text-align: center;
    }
  }
`;
